export default {
  methods: {
    goToPath(path) {
      if (path) {
        this.$router.push({path});
      } else {
        this.goToHomePage();
      }
    },
    goToHomePage() {
      this.$router.push({name: 'home'});
    },
    goToSignInPage() {
      this.$router.push({name: 'sign-in'});
    },
    goBack() {
      this.$router.back();
    }
  },
};
